import React from 'react';
import { format } from 'date-fns';

export const columns = [
  {
    name: 'Data/Hora',
    selector: (row) =>
      row.createdAt ? format(new Date(row.createdAt), 'dd/MM/yyyy HH:mm') : '-',
  },
  {
    name: 'Tipo Consulta',
    selector: (row) => row.queryType || '-',
  },
  {
    name: 'Documento',
    selector: (row) => row.document || '-',
  },
  {
    name: 'Retorno XML',
    cell: (row) => (
      <button
        type="button"
        className="btn btn-icon btn-secondary"
        onClick={() => alert(JSON.stringify(row.queryResponse))}
      >
        <i className="flaticon-eye"></i>
      </button>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
  },
  {
    name: 'Retorno JSON',
    cell: (row) => (
      <button
        type="button"
        className="btn btn-icon btn-secondary"
        onClick={() => alert(JSON.stringify(row.queryResponsePlain))}
      >
        <i className="flaticon-eye"></i>
      </button>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
  },
  {
    name: 'Link PDF',
    cell: (row) =>
      row.pdf ? (
        <a href={row.pdf} target="_blank" rel="noopener noreferrer">
          Visualizar
        </a>
      ) : (
        '-'
      ),
  },
];
